import type { ComponentType } from 'react';

import { enGBComponents, enUSComponents } from './lang';

import { LangCodes } from '@tsl-frontend/tsl-locale';

type ComponentRegistry = Record<LangCodes, Record<string, ComponentType>>;

export const componentRegistry: ComponentRegistry = {
    [LangCodes.GB]: enGBComponents,
    [LangCodes.US]: enUSComponents,
};
